<template>
  <v-container class="mb-4 mt-2 password-container">
    <v-row justify="center" no-gutters>
      <v-col cols="1"></v-col>
      <v-col
        cols="9"
        md="8"
        lg="8"
        class="text-h6 text-md-h5 text-lg-h5 font-weight-bold mt-2"
      >
        <div>Change Password</div>
      </v-col>
      <v-col cols="2" class="text-right">
        <v-btn icon @click="clearPassVals()" :disabled="password_object.changePasswordLoader">
          <v-icon large>fa-light fa-xmark</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <!-- <v-form ref="form" v-model="password_object.valid"> -->
    <v-form>
      <v-row no-gutters>
        <v-col cols="8" xl="6" class="py-4 ml-6 ml-md-10 ml-lg-14 ml-xl-18">
          <slot name="newPass"></slot>
        </v-col>
        <v-col class="py-6 ml-2 asterisk-icon" cols="2">
          <v-icon x-small color="#EA0028" class="ml-2">fa-asterisk</v-icon>
        </v-col>
      </v-row>

      <v-row no-gutters>
        <v-col cols="8" xl="6" class="ml-6 ml-md-10 ml-lg-14">
          <slot name="confirmPass"></slot>
        </v-col>
        <v-col class="py-2 ml-2 asterisk-icon" cols="2">
          <v-icon x-small color="#EA0028" class="ml-2">fa-asterisk</v-icon>
        </v-col>
      </v-row>
    </v-form>

    <v-row no-gutters>
      <v-col cols="2"></v-col>
      <v-col cols="10" class="text-right">
        <div
          class="text-center sign-alert"
          v-if="password_object.changePasswordLoader"
        >
          Please sign the registration using the Personal dekstop app.
        </div>
        <v-btn plain @click="clearPassVals()" class="cancel-password-btn" :disabled="password_object.changePasswordLoader"
          >Cancel</v-btn
        >
        <v-btn
          @click="
            changePasswordFunction({
              password: password_object.new_pass.newPass,
              device: currentDevice,
            })
          "
          class="change-password-btn"
          :loading="password_object.changePasswordLoader"
          style="background-color: #003088; color: #ffffff"
          :disabled="
            password_object.new_pass.newPass !== password_object.confirm_pass.confirmPass ||
            password_object.confirm_pass.confirmPass === null || password_object.changePasswordLoader
          "
          >Change</v-btn
        >
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  props: ["password_object", "currentDevice"],
  data() {
    return {};
  },
  methods: {
    changePasswordFunction({password, device}) {
      this.$emit("changePasswordFunction", {password, device});
    },
    clearPassVals() {
      this.$emit("clearPassVals");
    },
  },
};
</script>
<style></style>
